export default __webpack_public_path__ + "static/media/review_map.02fc25bb.png";